module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/109.86fbab99.png";